const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferencesRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 21.21,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 84.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 401.21,
    width: 38.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.71,
    y: 399.53,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 11.97,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.89,
    y: 395.31,
    width: 23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.89,
    y: 395.31,
    width: 48.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.03,
    y: 263.88,
    width: 15.4,
    height: 118.52,
    transform: "translate(165.46 646.28) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.43,
    y: 263.88,
    width: 134.79,
    height: 118.52,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.1,
    y: 308.61,
    width: 118.34,
    height: 63.39,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.1,
    y: 281.01,
    width: 118.34,
    height: 20.87,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.05,
    y: 308.6,
    width: 1.06,
    height: 63.39,
    transform: "translate(215.15 680.6) rotate(180)",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.05,
    y: 281.01,
    width: 1.06,
    height: 20.87,
    transform: "translate(215.15 582.89) rotate(180)",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.03,
    y: 268.88,
    width: 150.53,
    height: 2.68,
    transform: "translate(300.58 540.44) rotate(180)",
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.23,
    y: 262.26,
    width: 17.2,
    height: 7.75,
    transform: "translate(163.66 532.27) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.43,
    y: 262.26,
    width: 136.59,
    height: 7.75,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.85,239.5a8.07,8.07,0,0,1-1.45-4.16,13.12,13.12,0,0,1,.39-4.5,21,21,0,0,1,4.1-7.91,38,38,0,0,1,3-3.21c.56-.47,1.1-.95,1.67-1.41a20.09,20.09,0,0,1,1.72-1.32,42,42,0,0,1,3.66-2.27c1.3-.64,2.58-1.27,3.94-1.78-1,1.12-2,2.1-3,3.09s-1.95,2-2.95,3-1.88,2-2.84,3c-.47.49-.89,1-1.33,1.53a17,17,0,0,0-1.3,1.53,30.22,30.22,0,0,0-4.23,6.66A17,17,0,0,0,131,235.4,11.22,11.22,0,0,0,130.85,239.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48,235.31a11,11,0,0,0,.65-3.71,12.65,12.65,0,0,0-.13-1.75,12.4,12.4,0,0,0-.47-1.64,15.47,15.47,0,0,0-4-5.56c-.42-.42-.92-.78-1.37-1.18a12.4,12.4,0,0,0-1.43-1.15c-1-.7-1.95-1.53-3-2.18-.52-.35-1-.7-1.57-1.07s-1-.75-1.6-1.08a38.88,38.88,0,0,1-3.23-2.28,37.11,37.11,0,0,1,3.91.8,12.7,12.7,0,0,1,1.9.6c.62.24,1.24.48,1.86.74l.93.39c.3.14.59.32.89.48.59.32,1.17.67,1.76,1a13.42,13.42,0,0,1,1.68,1.18c.53.44,1.09.83,1.59,1.32a13.47,13.47,0,0,1,4.24,7.36,5,5,0,0,1,.11,1.09c0,.37,0,.74,0,1.1a9.31,9.31,0,0,1-.44,2.11A7.55,7.55,0,0,1,107.48,235.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.55,235.31a23.06,23.06,0,0,0,.19-8.05,21.56,21.56,0,0,0-2.53-7.19l-1-1.65c-.37-.53-.79-1-1.16-1.56l-.58-.8-.67-.73c-.44-.49-.88-1-1.31-1.51-.94-.95-1.93-1.88-2.89-2.88s-2.07-1.84-3.06-2.9a40.81,40.81,0,0,1,4,1.56,39.18,39.18,0,0,1,3.68,2.27c.56.46,1.13.93,1.68,1.41l.83.72.74.83c.48.56,1,1.12,1.43,1.71l1.2,1.9a17,17,0,0,1,2.24,8.67A13.53,13.53,0,0,1,108.55,235.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,236.79a39.32,39.32,0,0,1-5-8.11,53.39,53.39,0,0,1-3.29-9,44.19,44.19,0,0,1-1.38-9.52,27,27,0,0,1,1.45-9.5c.28,3.2.63,6.23,1.15,9.24s1.25,6,2,9,1.63,5.91,2.5,8.88S128.75,233.7,129.57,236.79Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,236.29a45.73,45.73,0,0,1-6.33-7.57,61.15,61.15,0,0,1-4.87-8.6,51.33,51.33,0,0,1-3.27-9.38,30.36,30.36,0,0,1-.72-9.91c1,3.17,2,6.17,3.22,9.14s2.48,5.85,3.79,8.76,2.72,5.78,4.11,8.69S127.24,233.24,128.53,236.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6,240.1a45.43,45.43,0,0,1-7.87-6,62.2,62.2,0,0,1-6.66-7.29,51.94,51.94,0,0,1-5.29-8.41,30.69,30.69,0,0,1-2.91-9.5c1.69,2.86,3.37,5.55,5.18,8.18s3.72,5.16,5.65,7.7,4,5,5.94,7.55S130.66,237.42,132.6,240.1Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,235.74a34.7,34.7,0,0,1-7.56-5.12,46.56,46.56,0,0,1-6.26-6.67,40.14,40.14,0,0,1-4.71-7.9,26.57,26.57,0,0,1-2.24-8.9c1.53,2.67,2.93,5.22,4.55,7.66s3.27,4.81,5,7.12,3.6,4.6,5.48,6.87S124.58,233.35,126.48,235.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,238.53a10,10,0,0,1-4.12-6.87,14.42,14.42,0,0,1,1.3-8.16l.42-.94.51-.88,1.07-1.73q.62-.8,1.26-1.56a15.59,15.59,0,0,1,1.33-1.48,33,33,0,0,1,3-2.57,33.84,33.84,0,0,1,3.34-2.08,38.47,38.47,0,0,1-2.17,3.22c-.74,1-1.4,2.1-2.14,3.09s-1.29,2.09-2,3.1l-.83,1.58-.44.78-.33.81a17.47,17.47,0,0,0-1.75,6.66A14.47,14.47,0,0,0,131.37,238.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,235.34a16.05,16.05,0,0,1-4.24-7.12,15.73,15.73,0,0,1-.12-8.61,14.56,14.56,0,0,1,1.75-4,15.74,15.74,0,0,1,2.74-3.32,17.86,17.86,0,0,1,7.17-4.12A54.77,54.77,0,0,0,131.6,214a21,21,0,0,0-1.94,3.13,16.09,16.09,0,0,0-1.29,3.35,19.3,19.3,0,0,0-.53,7.22A37.05,37.05,0,0,0,129.52,235.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.63 232.97 108.98 217.95 109.61 232.68 124.63 232.97",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.73 231.37 100.16 231.37 105.6 262.26 136.29 262.26 141.73 231.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.76 231.37 100.16 231.37 105.6 262.26 113.8 262.26 115.76 231.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.94,
    y: 76.83,
    width: 83.91,
    height: 105.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.16,
    y: 76.83,
    width: 99.22,
    height: 105.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.34,
    y: 88.27,
    width: 88.86,
    height: 82.6,
    transform: "translate(24.2 283.33) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.44 382.4 307.79 382.4 296.46 171.35 424.11 171.35 435.44 382.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.34 382.4 311.69 382.4 300.36 171.35 428.01 171.35 439.34 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.32 360.63 363.92 360.63 364.38 193.12 375.78 193.12 375.32 360.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.47 360.63 394.07 360.63 394.54 193.12 405.93 193.12 405.47 360.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.16 360.63 333.76 360.63 334.23 193.12 345.63 193.12 345.16 360.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-87"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-87",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.82,
    y: 305.37,
    width: 23.58,
    height: 1,
    transform: "translate(60.04 675.17) rotate(-86.86)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.95,
    y: 279.7,
    width: 12.15,
    height: 1,
    transform: "translate(87.01 652.31) rotate(-86.86)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,362.52H249.58a12.87,12.87,0,0,1-13-13.7l13.5-246.12A14.7,14.7,0,0,1,264.58,89H381.81a12.88,12.88,0,0,1,12.95,13.7L381.25,348.82A14.69,14.69,0,0,1,366.8,362.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.71,362.52H249.58a12.87,12.87,0,0,1-13-13.7l13.5-246.12A14.7,14.7,0,0,1,264.58,89H374.72a12.87,12.87,0,0,1,12.95,13.7l-13.5,246.12A14.71,14.71,0,0,1,359.71,362.52Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.13,133.62H273.5a5.43,5.43,0,0,1-5.46-5.79h0a6.2,6.2,0,0,1,6.1-5.78h31.63a5.42,5.42,0,0,1,5.46,5.78h0A6.21,6.21,0,0,1,305.13,133.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.23,127.83a11.12,11.12,0,0,1-11,10.41,9.75,9.75,0,0,1-9.84-10.41,11.12,11.12,0,0,1,11-10.41A9.75,9.75,0,0,1,311.23,127.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,170.63H271.47a5.43,5.43,0,0,1-5.46-5.79h0a6.2,6.2,0,0,1,6.1-5.78h31.63a5.42,5.42,0,0,1,5.46,5.78h0A6.21,6.21,0,0,1,303.1,170.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.82,
    cy: 164.84,
    rx: 10.7,
    ry: 10.13,
    transform: "translate(-34.27 245.31) rotate(-44.21)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.82,
    cy: 164.84,
    rx: 10.7,
    ry: 10.13,
    transform: "translate(-34.27 245.31) rotate(-44.21)",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,244.65H299a6.21,6.21,0,0,0,6.1-5.79h0a5.42,5.42,0,0,0-5.47-5.78H268.05a6.21,6.21,0,0,0-6.11,5.78h0A5.44,5.44,0,0,0,267.41,244.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.36,
    cy: 238.86,
    rx: 10.7,
    ry: 10.13,
    transform: "translate(-89.42 257.57) rotate(-44.21)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.36,
    cy: 238.86,
    rx: 10.7,
    ry: 10.13,
    transform: "translate(-89.42 257.57) rotate(-44.21)",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,281.66H265.38a5.44,5.44,0,0,1-5.47-5.79h0a6.21,6.21,0,0,1,6.11-5.78h31.62a5.42,5.42,0,0,1,5.47,5.78h0A6.21,6.21,0,0,1,297,281.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.11,275.87a11.12,11.12,0,0,1-11,10.41,9.76,9.76,0,0,1-9.85-10.41,11.14,11.14,0,0,1,11-10.41A9.75,9.75,0,0,1,303.11,275.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.44,207.64h31.63a6.21,6.21,0,0,0,6.1-5.79h0a5.42,5.42,0,0,0-5.47-5.78H270.08a6.2,6.2,0,0,0-6.1,5.78h0A5.43,5.43,0,0,0,269.44,207.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,201.85a9.75,9.75,0,0,0,9.84,10.41,11.12,11.12,0,0,0,11-10.41A9.75,9.75,0,0,0,275,191.44,11.12,11.12,0,0,0,264,201.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,201.85a9.75,9.75,0,0,0,9.84,10.41,11.12,11.12,0,0,0,11-10.41A9.75,9.75,0,0,0,275,191.44,11.12,11.12,0,0,0,264,201.85Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.41,126.1H327.53a2.18,2.18,0,0,1-2.18-2.32h0a2.48,2.48,0,0,1,2.44-2.31h46.88a2.17,2.17,0,0,1,2.18,2.31h0A2.48,2.48,0,0,1,374.41,126.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.79,134.2h-31.7a2.18,2.18,0,0,1-2.19-2.32h0a2.48,2.48,0,0,1,2.44-2.31h31.71a2.18,2.18,0,0,1,2.19,2.31h0A2.49,2.49,0,0,1,358.79,134.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.37,274.14h-41a2.18,2.18,0,0,1-2.18-2.32h0a2.47,2.47,0,0,1,2.44-2.31h40.95a2.18,2.18,0,0,1,2.19,2.31h0A2.49,2.49,0,0,1,360.37,274.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.21,282.23H319a2.18,2.18,0,0,1-2.19-2.31h0a2.48,2.48,0,0,1,2.44-2.31h20.24a2.18,2.18,0,0,1,2.19,2.31h0A2.48,2.48,0,0,1,339.21,282.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,166.58H325.31a2.48,2.48,0,0,0-2.44,2.31h0a2.18,2.18,0,0,0,2.19,2.31h46.88a2.48,2.48,0,0,0,2.44-2.31h0A2.18,2.18,0,0,0,372.19,166.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,158.48h-31.7a2.48,2.48,0,0,0-2.44,2.31h0a2.18,2.18,0,0,0,2.18,2.32h31.71a2.49,2.49,0,0,0,2.44-2.32h0A2.17,2.17,0,0,0,357.46,158.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.52,200.12h-24a2.18,2.18,0,0,1-2.18-2.32h0a2.47,2.47,0,0,1,2.44-2.31h24A2.18,2.18,0,0,1,350,197.8h0A2.49,2.49,0,0,1,347.52,200.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.35,200.12H356.19A2.18,2.18,0,0,1,354,197.8h0a2.48,2.48,0,0,1,2.44-2.31h14.17a2.17,2.17,0,0,1,2.18,2.31h0A2.49,2.49,0,0,1,370.35,200.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.73,208.21H323a2.18,2.18,0,0,1-2.19-2.31h0a2.48,2.48,0,0,1,2.44-2.31H355a2.18,2.18,0,0,1,2.19,2.31h0A2.48,2.48,0,0,1,354.73,208.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,314.7H261a3,3,0,0,1-3.06-3.24h0a3.48,3.48,0,0,1,3.42-3.24h54a3,3,0,0,1,3.06,3.24h0A3.47,3.47,0,0,1,315,314.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.14,314.7H330a3,3,0,0,1-3.06-3.24h0a3.48,3.48,0,0,1,3.42-3.24H363.5a3,3,0,0,1,3.06,3.24h0A3.48,3.48,0,0,1,363.14,314.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,326H260.4a3,3,0,0,1-3.06-3.24h0a3.47,3.47,0,0,1,3.42-3.24h41.09a3,3,0,0,1,3.06,3.24h0A3.47,3.47,0,0,1,301.5,326Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.13,337.36H259.78a3,3,0,0,1-3.06-3.24h0a3.47,3.47,0,0,1,3.41-3.24h86.35a3,3,0,0,1,3.06,3.24h0A3.47,3.47,0,0,1,346.13,337.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,240.6H321.25a2.48,2.48,0,0,0-2.44,2.31h0a2.18,2.18,0,0,0,2.19,2.31h13.88a2.48,2.48,0,0,0,2.44-2.31h0A2.18,2.18,0,0,0,335.13,240.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89,240.6H343.8a2.48,2.48,0,0,0-2.44,2.31h0a2.18,2.18,0,0,0,2.19,2.31h16.09a2.48,2.48,0,0,0,2.44-2.31h0A2.17,2.17,0,0,0,359.89,240.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,232.5H321.7a2.47,2.47,0,0,0-2.44,2.31h0a2.18,2.18,0,0,0,2.18,2.32h31.71a2.49,2.49,0,0,0,2.44-2.32h0A2.18,2.18,0,0,0,353.4,232.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,173.13c-3.27,2.71-6.65,5.66-9.76,8.62-1.56,1.49-3.08,3-4.49,4.56A39.57,39.57,0,0,0,160,191l-.19.28-.09.16a2.43,2.43,0,0,0-.21.4c-.14.31-.27.7-.41,1.11a21.87,21.87,0,0,0-.62,2.77,59.31,59.31,0,0,0-.6,6.3c-.21,4.32-.21,8.83-.13,13.24l-4.68.7a86.28,86.28,0,0,1-2.4-13.79,52.92,52.92,0,0,1-.17-7.27A29.47,29.47,0,0,1,151,191a15.87,15.87,0,0,1,.57-2.14c.15-.39.26-.75.46-1.16l.28-.6c.1-.18.17-.29.25-.45a40.34,40.34,0,0,1,4.27-6.25,70.32,70.32,0,0,1,4.77-5.36,104.76,104.76,0,0,1,10.52-9.41Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,161.14c-5.12,3-12.86,10.8-12.86,10.8l9.49,11.39s13.47-8.08,15.11-12.53C190.73,163.31,181.09,158.27,176.25,161.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,213.57l1.16,6.77-6.29-.91s-1.29-4.6,2-6.18Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.38 224.46 150.72 222.7 152.41 219.43 158.7 220.34 156.38 224.46",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.32,137.22c0,.69.38,1.25.84,1.26s.81-.55.8-1.23-.38-1.25-.84-1.26S214.31,136.54,214.32,137.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.92,136l1.67-.45S215.75,136.85,214.92,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,137.9a19,19,0,0,0,2.54,4.43,3,3,0,0,1-2.47.42Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,132.65a.35.35,0,0,1-.2,0,3.36,3.36,0,0,0-3,.35.4.4,0,0,1-.57-.08.41.41,0,0,1,.08-.57,4.21,4.21,0,0,1,3.72-.47.41.41,0,0,1,.26.51A.43.43,0,0,1,215.19,132.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.94,144.56c.46,5.17-1.27,13.64-5.17,16.52,0,0,2.94,5.44,12.36,6.71,10.37,1.39,5.5-4.44,5.5-4.44-5.51-2.1-4.93-6.25-3.53-10Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.35,167.37c4.93,1.34,10.11,2.63,15.19,3.78,2.56.55,5.12,1,7.68,1.55s5.13.9,7.68,1.23l1,.13.66.07c.46,0,1,0,1.5,0a26.69,26.69,0,0,0,3.46-.47,70.37,70.37,0,0,0,7.33-1.93c4.93-1.54,9.93-3.4,14.82-5.32l2.22,4.17a105.64,105.64,0,0,1-14.47,7.93,65.08,65.08,0,0,1-8,3,33.79,33.79,0,0,1-4.45,1,24.28,24.28,0,0,1-2.5.21l-1.36,0-1-.08a131.38,131.38,0,0,1-16.4-2.18,153.3,153.3,0,0,1-16-3.88Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.37,168.1l1.45-4.91,5.33,2s-1.22,7.38-5.79,5.34Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.91 159.93 280.35 160.54 277.15 165.19 271.82 163.19 274.91 159.93",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.64 406.87 187.21 407.5 189.76 387.82 181.19 387.19 178.64 406.87",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.44 368.72 121.26 375.18 137.52 363.94 131.7 357.49 115.44 368.72",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57,378.84a1.18,1.18,0,0,1-.31,0c-1-.34-1.75-2.27-2.08-3.39a.2.2,0,0,1,.29-.23c.31.16,3.07,1.66,3.16,2.76a.69.69,0,0,1-.29.62A1.22,1.22,0,0,1,125.57,378.84Zm-1.85-3.07c.5,1.48,1.11,2.45,1.67,2.63a.73.73,0,0,0,.7-.17.31.31,0,0,0,.14-.27C126.18,377.38,124.81,376.4,123.72,375.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,376.17a6.14,6.14,0,0,1-2.63-.65.22.22,0,0,1-.1-.18.18.18,0,0,1,.11-.17c.08-.05,2.2-1.22,3.37-.82a1.09,1.09,0,0,1,.68.63.7.7,0,0,1-.16.88A2,2,0,0,1,125.9,376.17Zm-2.08-.83c1,.41,2.64.6,3.09.22.07-.07.15-.17,0-.42a.7.7,0,0,0-.43-.41A4.56,4.56,0,0,0,123.82,375.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,374.23l-4.8-8.52a.69.69,0,0,0-.85-.32l-7.09,2.72a1.39,1.39,0,0,0-.62,2c1.73,2.94,2.7,4.27,4.81,8,1.3,2.3,3.3,7.33,4.84,10.64s4.8,2,4.45.5a30.15,30.15,0,0,1-.48-13.48A2.29,2.29,0,0,0,123.87,374.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.94,407.78a15,15,0,0,1-2.7-.3.21.21,0,0,1-.16-.17.2.2,0,0,1,.11-.21c.39-.2,3.87-2,4.9-1.37a.64.64,0,0,1,.33.54,1.16,1.16,0,0,1-.4,1A3.28,3.28,0,0,1,190.94,407.78Zm-2-.59c1.89.31,3.3.23,3.84-.24a.76.76,0,0,0,.25-.65.25.25,0,0,0-.12-.22C192.32,405.77,190.35,406.51,188.92,407.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28,407.48a.19.19,0,0,1-.12,0,.18.18,0,0,1-.08-.18c0-.16.41-3.66,2.33-3.66h.17c.55.05.71.33.75.56.16,1-1.92,2.83-3,3.29A.15.15,0,0,1,188.28,407.48Zm2.14-3.48c-1.24,0-1.73,2-1.88,2.91,1.07-.64,2.48-2.09,2.39-2.68,0,0,0-.18-.39-.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.75,406.28h-9.64a.71.71,0,0,0-.7.59l-1.29,7.62a1.35,1.35,0,0,0,1.34,1.53c3.36-.06,5-.26,9.22-.26,2.6,0,8,.27,11.59.27s3.88-3.55,2.39-3.88c-6.68-1.44-9.28-3.44-11.49-5.34A2.21,2.21,0,0,0,187.75,406.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.76 387.83 188.34 398.77 179.87 397.35 181.18 387.19 189.76 387.83",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.69 357.49 137.51 363.95 130.79 368.59 124.76 362.28 131.69 357.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,212.73,209,217.39c13.45-48.69,9.48-50,9.48-50a69.7,69.7,0,0,0-8-3.16l-.47-.15c-2.24-.68-2.71-.77-5.7-1.45-5.13-.91-9.89-1.61-15.77-2.11-.37,0-.75-.07-1.12-.09-1.06-.07-2.11-.12-3.13-.16-.68,0-1.37,0-2,0h-3.38a4.81,4.81,0,0,0-4.67,5.36C177.21,191.2,176.27,199.63,174.32,212.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,178.4c.24,2.26,5.46,6.39,7.27,5.28.52-2.71.9-5,1.17-6.84C215.82,176.64,210.69,173.75,210,178.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,167c-.25-8,19.14.81,23.59,2.8L223,183.21s-6.49-.22-10.62-2.61A16.76,16.76,0,0,1,204.37,167Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,135c.64,8.46.73,12.05,5.11,16.45,6.57,6.61,16.92,4.27,18.84-4.14,1.73-7.57.39-20.13-8-23.61A11.35,11.35,0,0,0,191,135Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.74,126.07c-8.5-2.13-8.77,5-8.59,8.76s-6.07,5.56-6.07,10.27c0,6.14,4.63,9.8-6.63,11.66-9.53,1.57-12.47,13.48,1.63,20.45,15.61,7.7,39.16-3.14,36.3-13.45C204,147.85,211.87,147.9,211,139c-.65-6.46,5.47-6.78,3.27-12.17C211.37,119.78,191,113.59,191.74,126.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.9,138c-1.17-6.16-.53-10.24,1.9-12.15,3.13-2.47,7.94-.33,8.14-.24l-.41.91s-4.47-2-7.12.11c-2.11,1.67-2.62,5.43-1.53,11.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,155a19.49,19.49,0,0,1-6.41-1.3l.37-.93c.07,0,6.81,2.68,9.93.09,1.52-1.26,1.95-3.62,1.29-7l1-.19c.74,3.79.19,6.48-1.63,8A7,7,0,0,1,172.29,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,138.41a7.67,7.67,0,0,0,1.17,4.48c1.16,1.89,2.73,1.54,3.24-.06s.42-4.17-1.15-5.54S208.85,136.66,208.69,138.41Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.87,216.16s-13.48,57-19.78,89.69c-6.64,34.53-46,62.7-46,62.7l-8.64-8.89s25.34-22.18,31.85-54.42c13.21-65.44,4.27-78.62,17-92.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.83 369.83 124.04 358.73 127.07 355.47 139.6 366.5 134.83 369.83",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.71,228.54c-10.48,9.1-9.35,41.39-8.25,55.94,4.39-20.69,9.68-43.73,12.78-57.06C196.13,226.6,194.63,226.87,192.71,228.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,217.42s6.06,67.63,2.75,93.43c-3.44,26.83-21,85.21-21,85.21L178,394.47s10-57.86,11.83-84.42c1.94-29-6.69-96-6.69-96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.95 396.77 175.33 394.49 175.6 389.29 194.72 391.14 192.95 396.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,210.64l-1.9,2.87c-.14.23.12.51.52.56L209,219c.31,0,.59-.08.63-.27l.64-3c.05-.21-.21-.43-.55-.48l-35.15-4.71A.6.6,0,0,0,174,210.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,210.64l-1.9,2.87c-.14.23.12.51.52.56L209,219c.31,0,.59-.08.63-.27l.64-3c.05-.21-.21-.43-.55-.48l-35.15-4.71A.6.6,0,0,0,174,210.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,215.17l-.94-.12c-.19,0-.32-.14-.29-.26l.86-3.95c0-.11.2-.18.39-.16l.94.13c.19,0,.32.14.3.25l-.87,3.95C178.69,215.13,178.51,215.2,178.32,215.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.1,218.42l-.94-.13c-.19,0-.32-.14-.3-.25l.87-3.95c0-.11.2-.19.39-.16l.94.12c.19,0,.32.14.29.26l-.86,3.95C202.46,218.37,202.29,218.45,202.1,218.42Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesRafiki);
export default __webpack_public_path__ + "static/media/Preferences-rafiki.3f0f36e9e78d41b14b23004777e6d73d.svg";
export { ForwardRef as ReactComponent };